
import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import { SubscriptionFormValues } from "./SubscriptionFormSchema";

interface SubscriptionManualActivationFieldProps {
  control: Control<SubscriptionFormValues>;
}

export function SubscriptionManualActivationField({
  control,
}: SubscriptionManualActivationFieldProps) {
  const { t } = useTranslation("subscriptions");
  
  return (
    <FormField
      control={control}
      name="isManuallyActivated"
      render={({ field }) => (
        <FormItem className="flex flex-row items-center justify-between rounded-lg border p-3">
          <div className="space-y-0.5">
            <FormLabel className="text-base">{t("manualActivation")}</FormLabel>
            <FormDescription>
              {t("manualActivationDescription")}
            </FormDescription>
          </div>
          <FormControl>
            <Switch
              checked={field.value}
              onCheckedChange={field.onChange}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
}
